module.exports = require("core-js-pure/features/object/get-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/object/get-prototype-of.js
// module id = 523
// module chunks = 0 1